import { render } from "./ShopCalendar.vue?vue&type=template&id=014cba54"
import script from "./ShopCalendar.vue?vue&type=script&lang=js"
export * from "./ShopCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__